import { render, staticRenderFns } from "./zhenProperty.vue?vue&type=template&id=2c2089ae&scoped=true"
import script from "./zhenProperty.vue?vue&type=script&lang=js"
export * from "./zhenProperty.vue?vue&type=script&lang=js"
import style0 from "./zhenProperty.vue?vue&type=style&index=0&id=2c2089ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2089ae",
  null
  
)

export default component.exports